import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_BRANDS as GET_BRANDS,
  CREATE_BRAND,
  UPDATE_CURRENT_BRAND,
  UPDATE_BRAND,
  GET_BRANDS_TRANSACTIONS
} from "./actionTypes"

import {
  getBrandsSuccess as getBrandsSuccess,
  getBrandsError as getBrandsError,
  createBrandSuccess,
  createBrandError,
  updateCurrentBrand,
  updateBrandSuccess,
  updateBrandError,
  getBrandsTransactionsSuccess,
  getBrandsTransactionsError
} from "./actions"

import {
  getBrands,
  createBrand,
  sfGenericRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { setCurrentBrandIfNotSet } from "helpers/sf_brand_helper"

function* onGetBrands() {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      getBrands,
      `${AppConfiguration.BACKEND_URL}/api/v1/brands`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    if (response?.length > 0) {
      setCurrentBrandIfNotSet(response[0])
    }
    yield put(getBrandsSuccess(response))
  } catch (error) {
    yield put(getBrandsError(error))
  }
}

function* onGetBrandsTransactions() {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      getBrands,
      `${AppConfiguration.BACKEND_URL}/api/v1/brands_last_transactions`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(getBrandsTransactionsSuccess(response))
  } catch (error) {
    yield put(getBrandsTransactionsError(error))
  }
}

function* onCreateBrand(brand) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      createBrand,
      `${AppConfiguration.BACKEND_URL}/api/v1/brands`,
      {
        brand: {
          name: brand.payload.brandname,
          duplicate_brand_id: brand?.payload?.duplicate_brand_id
        },
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )

    yield put(createBrandSuccess(response))
    //Also set the newly created brand as the current brand
    yield put(updateCurrentBrand({
      brand: { id: response.id, name: response.name },
      history: null
    }))

  } catch (error) {
    yield put(createBrandError(error))
  }
}

function* onUpdateCurrentBrand(brand) {
  localStorage.setItem("current_brand", JSON.stringify({
    id: brand.payload.brand.id,
    name: brand.payload.brand.name
  }))

  if (brand.payload.history === null) {
    return
  }
  let are_we_on_campaign_page = brand.payload.history.location.includes("/campaigns") ? true : false;
  if (are_we_on_campaign_page === true) {
    brand.payload.history.history.push("/campaigns")
    return
  }
  let are_we_on_creatives_page = brand.payload.history.location.includes("/creatives") ? true : false;
  if (are_we_on_creatives_page === true) {
    brand.payload.history.history.push("/creatives")
    return
  }
  return

}


function* onUpdateBrand(brand) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      sfGenericRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/brands/${brand.payload.id}`,
      "PUT",
      {
        body: {
          name: brand.payload.name,
          active: brand.payload.active
        },
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )

    yield put(updateBrandSuccess(response))

  } catch (error) {
    yield put(updateBrandError(error))
  }
}

function* brandsSaga() {
  yield takeEvery(GET_BRANDS, onGetBrands)
  yield takeEvery(CREATE_BRAND, onCreateBrand)
  yield takeEvery(UPDATE_BRAND, onUpdateBrand)
  yield takeEvery(UPDATE_CURRENT_BRAND, onUpdateCurrentBrand)
  yield takeEvery(GET_BRANDS_TRANSACTIONS, onGetBrandsTransactions)
}

export default brandsSaga
